<template>
<div class="quizier-module module-quiz module-with-options">
    <div class="start-screen" v-if="start === false">
        <div class="screen" @click="start_quiz">
            <img v-if="settings_image" :src="settings_image" class="img-fluid rounded">
            <div class="desc-cont">
                <div class="button">
                    <button v-if="is_social_required()" class="btn btn-brand btn-facebook wfit animate__animated animate__pulse btn-lg animate__infinite" name="button"><i class="svg-24 svg-white btn-top" v-html="svg('facebook')"></i>
                        <span>{{ $t('i18n.continueFacebook') }}</span></button>
                    <button v-else-if="is_normal_button()" class="btn btn-secondary wfit animate__animated animate__pulse btn-large btn-lg animate__infinite" name="button">{{ $t('i18n.start_quiz_txt') }}</button>
                    <button v-else-if="is_login_required()" class="btn btn-secondary wfit animate__animated animate__pulse btn-large btn-lg animate__infinite" name="button">{{ $t('i18n.loginStartQuiz') }}</button>
                    <button v-else class="btn btn-secondary wfit animate__animated animate__pulse btn-large btn-lg animate__infinite" name="button">{{ $t('i18n.clickHereToFindout') }}</button>
                </div>
                <div class="description">{{ quiz_description }}</div>
            </div>
        </div>
    </div>
    <div class="calculating-results" v-else-if="!has_result">
        <div class="calc_container">
            <div class="results-bg"></div>
            <div class="loading-container">
                <div class="text-wrap">
                    <div class="loader">
                        <div class="lds-hourglass"></div>
                    </div>
                    <div class="text">{{ $t('i18n.calc_results') }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="quiz-result result-screen" v-else>
        <div class="preview" v-if="result_media">
            <img :src="result_media" :alt="result_title" class="img-fluid rounded">
        </div>
        <div class="result-txt description">
            <h3 class="result-title" v-html="result_title"></h3>
            <div class="result-description" v-html="result_desc"></div>
            <div class="share-widget mt-3 text-center">
                <div class="share-title">{{ $t('i18n.shareYourResult') }}</div>
                <div class="share-icons mt-2">
                    <ul class="module-share-icons" v-show="social=true">
                        <li><a class="share-button social-button is-twitter"><span v-html="svg('twitter')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-facebook"><span v-html="svg('facebook')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-pinterest"><span v-html="svg('pinterest')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-reddit"><span v-html="svg('reddit')" class="svg-gray svg-24"></span></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import mixinComponent from '../mixins';
const uuid = require('uuid');

export default {
    mixins: [mixinComponent],
    data() {
        return {
            loggedin: false,
            social: false,
            start: false,
            has_result: false,
            accessToken: false,
        }
    },
    computed: {
        results: function () {
            return this.has('results')
        },
        settings_image: function () {
            return this.setting(`cover_media_path`, false)
        },
        quiz_description: function () {
            return this.setting('post_description', '')
        },
        result_media: function () {
            return this.result('media_path', false)
        },
        result_title: function () {
            return this.result('heading', '')
        },
        result_desc: function () {
            return this.result('description', '')
        }
    },
    created: function () {

    },
    methods: {
        is_normal_button: function () {
            return (this.$variables && (this.$variables.is_loggedin && this.$variables.has_social))
        },
        is_login_required: function () {
            return (this.$variables && !this.$variables.is_loggedin)
        },
        is_social_required: function () {
            return (this.$variables && this.$variables.is_social_required)
        },
        has_user: function () {
            return (this.$variables && this.$variables.user)
        },
        async start_quiz() {
            if (this.is_social_required()) {
                await this.loadFacebookSDK(document, 'script', 'facebook-jssdk');
                await this.initFacebook();
                await this.logInWithFacebook();
            } else if (this.is_login_required() && !this.has_user()) {
                self.location.href = this.$variables.login_url
            } else if (this.has_user()) {
                await this.getUserInfo();
            }
        },
        async logInWithFacebook() {
            let $this = this
            if (typeof window.FB === 'undefined') {
                Quizier.sweetErrors(this.$t('i18n.trackingProtectionQuizError'));
            }
            window.FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                    $this.accessToken = response.authResponse.accessToken;
                    $this.getUserInfo()
                } else {
                    let $scope = 'email';
                    if(this.$variables.gender_permission) {
                        $scope += ',user_gender'
                    }
                    if(this.$variables.age_permission) {
                        $scope += ',user_age_range'
                    }
                    console.log($scope)
                    window.FB.login(function (response) {
                        if (response.authResponse) {
                            $this.accessToken = response.authResponse.accessToken;
                            $this.getUserInfo()
                        } else {
                            Quizier.sweetError($this.$t('i18n.denied'));
                        }
                    }, {
                        scope: $scope
                    });
                }
            });
        },
        async getUserInfo() {
            let $this = this
            this.start = true;
            if (this.accessToken) {
                let url = this.$variables.fb_redirect_url + '?noState=true&access_token=' + this.accessToken
                axios.get(url, {}).then(res => {
                    if (res.data.user) {
                        $this.loggedin = res.data.user
                        Quizier.get_nav();
                    } else if(res.data.action) {
                        this.resetQuiz();
                        Quizier.sweetError(res.data.action)
                    }
                }).catch(err => {
                    this.resetQuiz();
                    if (err.response && err.response.data && err.response.data.message) {
                        Quizier.sweetError(err.response.data.message)
                    }
                    return false;
                });
            } else {
                if (this.$variables.user) {
                    $this.loggedin = this.$variables.user
                } else {
                    this.resetQuiz();
                }
            }
        },
        async initFacebook() {
            if (window.FB) return;
            window.fbAsyncInit = function () {
                if (window.fb_app_id) {
                    window.FB.init({
                        appId: window.fb_app_id,
                        cookie: true,
                        version: "v6.0"
                    });
                }
            };
        },
        async loadFacebookSDK(d, s, id) {
            if (window.FB) return;
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        },
        between: function (x, min, max) {
            return x >= min && x <= max;
        },
        isInt: function (value) {
            return !isNaN(value) && (function (x) {
                return (x | 0) === x;
            })(parseFloat(value))
        },
        random: function (array) {
            return array[Math.floor(Math.random() * array.length)];
        },
        find_result: function () {
            const gender = this.loggedin.gender
            const age = this.calc_age(this.loggedin.dob)

            const results = this.has('results', [])
            var genderArray = results.filter(function (el) {
                return el.gender == gender || el.gender == 'Any';
            });

            var ageArray = genderArray.filter(function (obj) {
                if (obj.age_group == 'Any') {
                    if (age == obj.age_group) {
                        return true;
                    }
                } else if (isInt(age)) {
                    var ageArr = obj.age_group.split('-');
                    if (between(age, ageArr[0], ageArr[1])) {
                        return true;
                    } else if (age < ageArr[0]) {
                        return true;
                    } else if (age > ageArr[1]) {
                        return true;
                    }
                }
            });

            var finalArray = ageArray.length !== 0 ? ageArray : (genderArray.length !== 0 ? genderArray : results)
            var result = this.random(finalArray);

            if (typeof result == 'object') {
                const url = this.$variables.results_url;
                if (!url) {
                    Quizier.sweetError(this.$t('i18n.somethingWentWrong'));
                    this.resetQuiz();
                    return false;
                }
                const original_id = result.id;
                result.id = uuid.v4()

                let action = {};
                action['post_id'] = this.postID;
                action['block'] = this.me.index;
                action['result'] = result;
                action['original_id'] = original_id;
                action['url'] = url;
                if (!this.is_preview) {
                    axios.post(url, action).then(res => {
                        if (!res.data.error) {
                            this.has_result = res.data.action.result || result || []
                        }
                    }).catch(err => {
                        this.resetQuiz();
                        return false;
                    });
                } else {
                    this.has_result = res.data.action.result || result || []
                }
            } else {
                this.resetQuiz();
                Quizier.sweetError(this.$t('i18n.somethingWentWrong'));
            }
        },
        resetQuiz: function () {
            this.start = false;
        },
        calc_age: function (dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        },
        result: function (prop, def) {
            return this.deepget(this.has_result, prop, def);
        },
    },
    watch: {
        social: function () {
            const result = {id: this.result('id', false), title: this.result('title', false)}
            Quizier.setupSocial(result);
        },
        loggedin: function (newLoggedin, oldVal) {
            if (typeof newLoggedin == 'object') {
                this.find_result();
            }
        }
    }
}
</script>
